import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const GlossaryPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const glossaryData = [
    {
      id: 1,
      term: "QRC (量子リザバコンピューティング)",
      category: "quantum",
      definition: "Quantum Reservoir Computingの略。量子力学の原理を活用した新しい計算手法で、特に時系列データの予測や異常検知に優れている。従来のAIでは困難だった複雑なパターンの認識や、リアルタイムでの高精度予測が可能。",
      relatedTerms: ["量子機械学習", "時系列予測", "異常検知"]
    },
    {
      id: 2,
      term: "SLM (Small Language Model)",
      category: "ai",
      definition: "小規模言語モデル。大規模言語モデル（LLM）よりもパラメータ数が少なく、特定のドメインに特化した軽量なAIモデル。計算リソースが少なく済み、セキュリティ面でも優位性がある。DeepTeLLでは「Hamster」という名称で提供。",
      relatedTerms: ["LLM", "Hamster", "ドメイン特化"]
    },
    {
      id: 3,
      term: "BIM (Building Information Modeling)",
      category: "architecture",
      definition: "建築情報モデリング。建築物の3次元デジタルモデルを作成し、設計から施工、維持管理まで一貫して活用する手法。DeepTeLLでは生成AIを組み合わせて、平面図・立面図の自動生成から見積書作成まで自動化。",
      relatedTerms: ["3D可視化", "建築設計", "見積自動化"]
    },
    {
      id: 4,
      term: "CorPia",
      category: "platform",
      definition: "DeepTeLLが開発したAI駆動の人材マッチングプラットフォーム。求職者と企業の最適なマッチングを実現し、従来の人材紹介手数料を大幅に削減。年間2,450万円のコスト削減実績を持つ。",
      relatedTerms: ["人材マッチング", "AIマッチング", "コスト削減"]
    },
    {
      id: 5,
      term: "はしわたし",
      category: "agriculture",
      definition: "DeepTeLLが展開する農業プラットフォーム。農家と消費者を直接つなぎ、AI需要予測、インフルエンサーマーケティング、都市型プラント農業を組み合わせた新しいビジネスモデル。地方創生と食料自給率向上を目指す。",
      relatedTerms: ["都市型農業", "需要予測", "直販プラットフォーム"]
    },
    {
      id: 6,
      term: "つなぎスマイル",
      category: "platform",
      definition: "地域コミュニティ活性化プラットフォーム。地域住民や事業者をつなげ、コミュニティの絆を深める様々な機能を提供。AIを活用してイベント提案や人のマッチングを行う。",
      relatedTerms: ["地域活性化", "コミュニティ", "イベント提案"]
    },
    {
      id: 7,
      term: "量子機械学習",
      category: "quantum",
      definition: "量子コンピューティングと機械学習を組み合わせた技術領域。量子力学の重ね合わせやもつれなどの特性を活用して、従来の機械学習では困難な問題を解決する。DeepTeLLでは気象予測などに応用。",
      relatedTerms: ["QRC", "量子コンピューティング", "重ね合わせ"]
    },
    {
      id: 8,
      term: "Hamster",
      category: "ai",
      definition: "DeepTeLLが開発するカスタムSLM（小規模言語モデル）の名称。企業のドメインに特化した軽量で高精度な言語モデルで、チャットボットやAIエージェントのコア技術として活用される。",
      relatedTerms: ["SLM", "カスタムAI", "チャットボット"]
    },
    {
      id: 9,
      term: "PoC (Proof of Concept)",
      category: "development",
      definition: "概念実証。新しい技術やアイデアが実現可能であることを検証するための小規模な実験や試作。DeepTeLLでは本格導入前にPoCを実施し、効果を検証してからシステム開発を進める。",
      relatedTerms: ["プロトタイプ", "実証実験", "効果検証"]
    },
    {
      id: 10,
      term: "LGWAN",
      category: "security",
      definition: "Local Government Wide Area Networkの略。地方公共団体を相互に接続する行政専用のネットワーク。DeepTeLLは自治体向けにLGWAN対応のビジネスチャットアプリ「LGTalk」を開発。",
      relatedTerms: ["行政システム", "セキュリティ", "LGTalk"]
    },
    {
      id: 11,
      term: "時系列予測",
      category: "ai",
      definition: "過去のデータの時間的変化パターンを学習し、未来の値を予測する技術。DeepTeLLではQRCを活用して、収穫予測、需要予測、株価予測、発電量予測などに応用。",
      relatedTerms: ["QRC", "需要予測", "パターン認識"]
    },
    {
      id: 12,
      term: "異常検知",
      category: "ai",
      definition: "正常なパターンから逸脱したデータを自動的に検出する技術。製造業での設備故障予測、金融業での不正取引検知、インフラ監視などに活用される。",
      relatedTerms: ["パターン認識", "予防保全", "監視システム"]
    },
    {
      id: 13,
      term: "生成AI",
      category: "ai",
      definition: "テキスト、画像、音声、動画などのコンテンツを自動生成するAI技術。DeepTeLLでは建築BIMでの図面生成、コンテンツ作成支援などに活用。",
      relatedTerms: ["LLM", "コンテンツ生成", "BIM"]
    },
    {
      id: 14,
      term: "DPN (DeepTeLL Partner Network)",
      category: "community",
      definition: "DeepTeLLのビジネスパートナー向けコミュニティ。月額980円で最新AI情報、技術研修、ネットワーキング機会を提供。パートナーの成功を支援する。",
      relatedTerms: ["パートナーシップ", "コミュニティ", "研修"]
    },
    {
      id: 15,
      term: "量子アニーリング",
      category: "quantum",
      definition: "組合せ最適化問題を解くための量子計算手法。DeepTeLLでは経路最適化、ふるさと納税最適化、リソース配分などの問題解決に活用。",
      relatedTerms: ["最適化", "組合せ問題", "経路最適化"]
    },
    {
      id: 16,
      term: "自然言語処理 (NLP)",
      category: "ai",
      definition: "コンピューターが人間の言語を理解し、処理する技術。DeepTeLLではYouTube動画のキーワード抽出、SNS分析、チャットボット開発などに活用。",
      relatedTerms: ["テキスト解析", "キーワード抽出", "言語理解"]
    },
    {
      id: 17,
      term: "IoT (Internet of Things)",
      category: "technology",
      definition: "モノのインターネット。様々な機器がインターネットに接続され、データを収集・交換する仕組み。DeepTeLLでは空調制御、農業センサー、設備監視などに活用。",
      relatedTerms: ["センサー", "データ収集", "遠隔監視"]
    },
    {
      id: 18,
      term: "ROI (Return on Investment)",
      category: "business",
      definition: "投資収益率。投資に対してどれだけの利益が得られたかを示す指標。DeepTeLLでは顧客企業のAI導入効果を測定し、明確なROIを提示。",
      relatedTerms: ["投資効果", "コスト削減", "効果測定"]
    },
    {
      id: 19,
      term: "API (Application Programming Interface)",
      category: "technology",
      definition: "アプリケーション間でデータや機能を連携させるためのインターフェース。DeepTeLLでは気象データAPIの活用や、顧客システムとの連携に使用。",
      relatedTerms: ["システム連携", "データ連携", "インターフェース"]
    },
    {
      id: 20,
      term: "クラウドコンピューティング",
      category: "technology",
      definition: "インターネット経由でコンピューティングリソースを提供するサービス。DeepTeLLではAWS等のクラウドプラットフォームを活用してサービスを提供。",
      relatedTerms: ["AWS", "スケーラビリティ", "インフラ"]
    }
  ];

  const categories = [
    { key: 'all', label: '全て', icon: 'ALL' },
    { key: 'quantum', label: '量子技術', icon: 'QUANTUM' },
    { key: 'ai', label: 'AI・機械学習', icon: 'AI' },
    { key: 'platform', label: 'プラットフォーム', icon: 'PLATFORM' },
    { key: 'agriculture', label: '農業', icon: 'AGRICULTURE' },
    { key: 'architecture', label: '建築', icon: 'ARCHITECTURE' },
    { key: 'security', label: 'セキュリティ', icon: 'SECURITY' },
    { key: 'development', label: '開発', icon: 'DEVELOPMENT' },
    { key: 'community', label: 'コミュニティ', icon: 'COMMUNITY' },
    { key: 'technology', label: '技術', icon: 'TECHNOLOGY' },
    { key: 'business', label: 'ビジネス', icon: 'BUSINESS' }
  ];

  const filteredGlossary = glossaryData.filter(item => {
    const matchesSearch = item.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.definition.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <Layout 
      title="用語集" 
      subtitle="DeepTeLLで使用される技術用語や専門用語の解説"
    >
      {/* 検索・フィルター */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-md-offset-3" style={{ marginBottom: '30px' }}>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="用語を検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '15px 20px 15px 50px',
                    borderRadius: '25px',
                    border: '1px solid rgba(59, 130, 246, 0.3)',
                    background: 'rgba(30, 41, 59, 0.8)',
                    color: '#f1f5f9',
                    fontSize: '16px'
                  }}
                />
                <div style={{ 
                  position: 'absolute',
                  left: '20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#94a3b8',
                  fontSize: '18px'
                }}>
                  🔍
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                  {categories.map((category) => (
                    <button
                      key={category.key}
                      onClick={() => setSelectedCategory(category.key)}
                      style={{
                        padding: '10px 20px',
                        borderRadius: '20px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: selectedCategory === category.key ? '#3b82f6' : 'transparent',
                        color: selectedCategory === category.key ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        fontSize: '14px'
                      }}
                    >
                      {category.icon} {category.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 検索結果統計 */}
      <section style={{ padding: '20px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center' }}>
                <p style={{ color: '#94a3b8', margin: 0 }}>
                  {filteredGlossary.length}件の用語が見つかりました
                  {searchTerm && ` (「${searchTerm}」の検索結果)`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 用語一覧 */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            {filteredGlossary.length > 0 ? (
              filteredGlossary.map((item) => (
                <div key={item.id} className="col-md-6" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                      <h3 style={{ color: '#3b82f6', margin: 0, flex: 1 }}>
                        {item.term}
                      </h3>
                      <span style={{ 
                        background: 'rgba(59, 130, 246, 0.2)',
                        color: '#3b82f6',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        marginLeft: '10px'
                      }}>
                        {categories.find(cat => cat.key === item.category)?.icon} {categories.find(cat => cat.key === item.category)?.label}
                      </span>
                    </div>

                    <p style={{ color: '#cbd5e1', lineHeight: '1.6', marginBottom: '20px', fontSize: '14px' }}>
                      {item.definition}
                    </p>

                    {item.relatedTerms && item.relatedTerms.length > 0 && (
                      <div>
                        <h6 style={{ color: '#f1f5f9', marginBottom: '10px', fontSize: '12px' }}>関連用語</h6>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                          {item.relatedTerms.map((relatedTerm, index) => (
                            <span key={index} style={{ 
                              background: 'rgba(16, 185, 129, 0.2)',
                              color: '#10b981',
                              padding: '3px 8px',
                              borderRadius: '10px',
                              fontSize: '11px'
                            }}>
                              {relatedTerm}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12" style={{ textAlign: 'center', padding: '60px 0' }}>
                <div style={{ color: '#94a3b8', fontSize: '18px' }}>
                  🔍 該当する用語が見つかりませんでした
                </div>
                <p style={{ color: '#94a3b8', marginTop: '15px' }}>
                  検索条件を変更してお試しください
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 用語追加リクエスト */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                わからない用語がありましたか？
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                用語の追加リクエストや詳しい説明をご希望の場合は、<br />
                お気軽にお問い合わせください。
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                                      用語追加をリクエスト
                </a>
                <a href="/faq" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  border: '2px solid white',
                  color: '#1e40af'
                }}>
                  ❓ よくある質問を見る
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default GlossaryPage; 